export default __webpack_public_path__ + "static/media/sub-category-coworking-DeskSpace.da7baeb7.jpg";